var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestigative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06154 13.4918L9.23077 11.9998L6.06154 10.5077L4.61538 7.23788L3.16923 10.5077L0 11.9998L3.16923 13.4918L4.61538 16.7617L6.06154 13.4918ZM12.6154 23.1109L11.1692 19.8411L8 18.349L11.1692 16.8569L12.6154 13.5871L14.0615 16.8569L17.2308 18.349L14.0615 19.8411L12.6154 23.1109Z",
    fill: "url(#paint0_linear_8190_10858)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9385 8.17439L14.6154 11.9998L16.2923 8.17439L20 6.44423L16.2923 4.71407L14.6154 0.888672L12.9385 4.71407L9.23077 6.44423L12.9385 8.17439Z",
    fill: "url(#paint1_linear_8190_10858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8190_10858",
    x1: 0.0000122928,
    y1: 0.999978,
    x2: 18.7468,
    y2: 15.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#32CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBCDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8190_10858",
    x1: 0.0000122928,
    y1: 0.999978,
    x2: 18.7468,
    y2: 15.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#32CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBCDFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigative);
export default __webpack_public_path__ + "static/media/investigative.2ada6cf2c238f74a2630c3d8102d7ab4.svg";
export { ForwardRef as ReactComponent };